const CHARS = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789'

export class ImageCaptcha {
  private canvas: HTMLCanvasElement
  private ctx: CanvasRenderingContext2D
  private _code = ''

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas
    this.ctx = canvas.getContext('2d') as CanvasRenderingContext2D
    this.canvas.style.cursor = 'pointer'
    this.canvas.title = '点击刷新'
    this.canvas.addEventListener('click', () => this.reset())
    this._draw()
  }

  private _rand(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  private _color(min: number, max: number, alpha?: number): string {
    const r = this._rand(min, max)
    const g = this._rand(min, max)
    const b = this._rand(min, max)
    return alpha !== undefined
      ? `rgba(${r},${g},${b},${alpha})`
      : `rgb(${r},${g},${b})`
  }

  private _draw(): void {
    const ctx = this.ctx
    const w = this.canvas.width // 120
    const h = this.canvas.height // 40

    // 生成 4 位随机字符
    this._code = ''
    for (let i = 0; i < 4; i++) {
      this._code += CHARS[this._rand(0, CHARS.length - 1)]
    }

    // 背景渐变
    ctx.fillStyle = '#f0f4ff'
    ctx.fillRect(0, 0, w, h)
    const grad = ctx.createLinearGradient(0, 0, w, h)
    grad.addColorStop(0, this._color(210, 235, 0.6))
    grad.addColorStop(1, this._color(195, 225, 0.6))
    ctx.fillStyle = grad
    ctx.fillRect(0, 0, w, h)

    // 干扰线（5 条）
    for (let k = 0; k < 5; k++) {
      ctx.beginPath()
      ctx.moveTo(this._rand(0, w), this._rand(0, h))
      ctx.lineTo(this._rand(0, w), this._rand(0, h))
      ctx.strokeStyle = this._color(120, 190, 0.7)
      ctx.lineWidth = this._rand(1, 2)
      ctx.stroke()
    }

    // 噪点
    for (let n = 0; n < 45; n++) {
      ctx.beginPath()
      ctx.arc(this._rand(0, w), this._rand(0, h), 1, 0, 2 * Math.PI)
      ctx.fillStyle = this._color(140, 210, 0.9)
      ctx.fill()
    }

    // 字符（随机旋转 + 随机颜色 + 随机大小）
    ctx.textBaseline = 'middle'
    for (let j = 0; j < 4; j++) {
      ctx.font = `bold ${this._rand(19, 25)}px Arial, sans-serif`
      ctx.fillStyle = this._color(20, 110)
      ctx.save()
      ctx.translate(14 + j * 26, h / 2 + this._rand(-3, 3))
      ctx.rotate(this._rand(-28, 28) * Math.PI / 180)
      ctx.fillText(this._code[j], 0, 0)
      ctx.restore()
    }
  }

  verify(input: string): boolean {
    return !!input && input.toLowerCase() === this._code.toLowerCase()
  }

  reset(): void {
    this._draw()
  }
}
